import { Container, Grid, makeStyles, Typography } from '@material-ui/core';
import React, { useContext } from 'react';
import { LanguageContext } from '../Language/LanguageProvider';
import AnimatedBackground from '../ui/AnimatedBackground';
import usePageStyle from './usePageStyle';
import tienda from '../assets/remerastienda.jpg';
import Tag from '../ui/Tag';

const useLocalStyle = makeStyles(theme => ({
  mb2: {
    marginBottom: '2em',
  },
  mb1: {
    marginBottom: '1em',
  },
  imageContainer: {
    alignSelf: 'stretch',
  },
  link: {
    textDecoration: 'none',
    color: 'violet',
  },
  description: {
    zIndex: 999,
  },
  image: {
    height: '90%',
    width: '90%',
  },
}));

const MyWork = () => {
  const classes = usePageStyle();
  const localClasses = useLocalStyle();
  const { dictionary } = useContext(LanguageContext);
  return (
    <>
      <AnimatedBackground />
      <main className={classes.page} style={{ paddingTop: '1em' }}>
        <Container maxWidth="lg">
          <Typography className={localClasses.mb2} variant="h4" align="center">
            {dictionary['portfolio-title']}
          </Typography>
          <Grid container justify="space-between" direction="row" spacing={2}>
            <Grid container item lg={7} direction="column" justify="flex-start">
              <Grid item className={localClasses.mb2}>
                <Typography variant="h6" align="center">
                  {dictionary['portfolio-work-title']}
                </Typography>
              </Grid>
              <Grid
                item
                className={(localClasses.mb1, localClasses.description)}
              >
                <Typography paragraph variant="body1">
                  {dictionary['portfolio-description']}
                  <a
                    className={localClasses.link}
                    href="https://remerasjacqui.com.ar"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {dictionary['portfolio-link']}
                  </a>
                </Typography>
              </Grid>
              <Grid item className={localClasses.mb2}>
                <Typography variant="subtitle2" className={localClasses.mb1}>
                  {dictionary['portfolio-technologies']}{' '}
                </Typography>
                <Grid container item spacing={2}>
                  <Grid item>
                    <Tag text="React" />
                  </Grid>
                  <Grid item>
                    <Tag text="Redux" />
                  </Grid>
                  <Grid item>
                    <Tag text="Express" />
                  </Grid>
                  <Grid item>
                    <Tag text="Mongo" />
                  </Grid>
                  <Grid item>
                    <Tag text="Scss" />
                  </Grid>
                  <Grid item>
                    <Tag text="Node" />
                  </Grid>
                  <Grid item>
                    <Tag text="Bootstrap" />
                  </Grid>
                  <Grid item>
                    <Tag text="Git" />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid item lg={5} className={localClasses.imageContainer}>
              <img src={tienda} className={localClasses.image} alt="tienda" />
            </Grid>
          </Grid>
        </Container>
      </main>
    </>
  );
};

export default MyWork;
